var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPasswordReminder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.892,
    height: 24.187,
    viewBox: "0 0 20.892 24.187",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "password",
    d: "M59.635,0a5.965,5.965,0,0,0-6,5.915,5.908,5.908,0,0,0,3.648,5.442V19.73a.641.641,0,0,0,.422.6l1.7.629a.658.658,0,0,0,.457,0l1.7-.629a.642.642,0,0,0,.422-.6V18.8a.636.636,0,0,0-.19-.453l-.878-.865.878-.865a.636.636,0,0,0,.19-.453v-.719a.636.636,0,0,0-.19-.453l-.878-.865.878-.865a.636.636,0,0,0,.19-.453V11.357a5.908,5.908,0,0,0,3.648-5.442A5.965,5.965,0,0,0,59.635,0Zm0,5.214A1.517,1.517,0,1,1,61.173,3.7,1.529,1.529,0,0,1,59.635,5.214Z",
    transform: "rotate(30 32.067 -80.49)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPasswordReminder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_password_reminder.174b5f6a558da387d14395e46b091c9a.svg";